import React from "react";
import TradingViewWidget, { Themes } from "react-tradingview-widget";

import { useGameDetails } from "utils/Hooks";
import "pages/styles.scss";

function Chart() {
  const gameDetails = useGameDetails();

  return (
    <div className='ChartContainer'>
      <div>
        <TradingViewWidget
          symbol={"BINANCE:" + gameDetails.tickerSymbol + "USDT"}
          theme={Themes.DARK}
          interval="5"
          locale="en"
          autosize
        />
      </div>
    </div>
  );
}

export default Chart;
